module.exports = __webpack_public_path__ + "img/green-circle-accents.fa9ba628.png";